// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__30zGJ","cell":"ColumnAccessor_cell__1huYa","firstCellAccent":"ColumnAccessor_firstCellAccent__OED7E"};